import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx, Fragment } from 'react/jsx-runtime';

var _Link = function _Link(_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  if (!props.href) {
    return jsx(Fragment, {
      children: children
    });
  }
  return jsx("a", Object.assign({}, props, {
    children: children
  }));
};
var Link = function Link(_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return jsx(_Link, Object.assign({}, props, {
    children: children
  }));
};
var setupBlockitLink = function setupBlockitLink(Component) {
  _Link = Component;
};

export { Link, setupBlockitLink };
